import styled from 'styled-components';
import DocsCarrierInfo from './DocsCarrierInfo';

export default styled(DocsCarrierInfo)`
  .docs-carrier-info {
    background-color: var(--grey100);
    display: flex;
    flex-direction: column;
    padding: 2rem 5rem;

    &__title {
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    &__body {
      display: flex;
    }

    &__section {
      border-right: 1px solid var(--grey500);
      color: var(--grey900);
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      font-size: 1.4rem;
      padding: 0 2.4rem;

      &:first-of-type {
        padding-left: 0;
      }

      &:last-of-type {
        border: 0;
      }
    }

    &__label {
      margin-right: 0.8rem;
      &--inline {
        display: flex;
      }
      &--button {
        cursor: pointer;
      }
    }
  }
`;
